export default __webpack_public_path__ + "7165171ef8d67d39193e2f4be2f2ae8e.svg";